import transferValues from './transferValue'

export default (app) => {
    const store = app.config.globalProperties.$store
    return {
        getEstruturaBoxes(boxes) {
            //boxes

            let ret = {};
            
            // filtro adicionado para contornar problema de não excluir totalmente um objeto de um card mas ele estar sem boxProperties, ocasionando erro
            boxes.filter(box => (!box.id.includes("_") || !box.id.includes("_0_")) && box.component).forEach(box => {
                //box
                var propsBox = this.getPropriedadesValidasDoObjeto(box, ['devProps', 'objeto', 'component', 'componentObj', 'dadosProprios', 'creationInfo', 'state', 'pixel', 'size']);

                //option
                let optionProps = box.component.boxProperties;
                let keys = Object.keys(optionProps).filter(k => !!optionProps[k] && optionProps[k].command && optionProps[k].params && !optionProps[k].ignore);

                //console.log('Box:', box)
                //console.log('KEYS:', keys)

                let props = [];
                for(var k of keys) {

                    let params = []
                    //expand com boolean action
                    if (optionProps[k].expand)
                    {
                        if (!optionProps[k].booleanAction?.prop)
                            continue;
                            
                        //params = [optionProps[k].booleanAction.prop, optionProps[k].booleanAction.value];
                        //    
                        //props.push({
                        //    command: optionProps[k].booleanAction.command,
                        //    params,
                        //    array_index: optionProps[k].array_index
                        //})

                        params = [];

                        if (optionProps[k].array_index != undefined)
                            params = [optionProps[k].array_index];
                        params = [...params, ...[optionProps[k].booleanAction.prop, optionProps[k].booleanAction.value]];

                        props.push({
                            command: optionProps[k].command,
                            params,
                            array_index: optionProps[k].array_index
                        })
                        continue;
                    }

                    params = optionProps[k].params.constructor.name == 'Array' ? [...optionProps[k].params] : [optionProps[k].params];
                    //if (params.constructor.name != 'Array')
                    //    params = [params];
                    params.push(optionProps[k].value);


                    props.push({
                        command: optionProps[k].command,
                        params,
                        array_index: optionProps[k].array_index
                    })
                }

                //console.log('>', box.type, box.component.$children.constructor.name, box.component.$children.length, box.component.$children[0])
                ret[box.id] = {
                    box: propsBox,
                    dev: props
                };
                if (box.componentObj.$data) {
                    ret[box.id].own = box.componentObj.$data.dados
                }
            });
            
            return ret;
        },

        resolveCor(objCor, valDef) {
            if (objCor != undefined){
                if (app.config.globalProperties.$vistra.estaNoModoEscuro() == true)
                    return objCor.corEscura || valDef;
                return objCor.corClara || valDef;
            }
        },

        //pega o idPaleta e o idCor e retorna o objeto completo
        // resolveFullCor(idPaleta, idCor) {
        //     let paleta = store.getters.paletasCores.find(p => p.id == idPaleta);
        //     if (!paleta)
        //         return undefined;
        //     return paleta.cores.find(c => c.id == idCor);
        // },

        setValue(obj, param, value) {
            var tmp = obj;
            var path = param.split('.');
            path.forEach((p, i) => {
                if (i == path.length-1)
                    tmp[p] = value; //final do caminho, seta o valor
                else {
                    let arrayMatches = p.match(/\[(.*?)\]/);
                    if (arrayMatches) {
                        let prop = p.split('[')[0];
                        let index = arrayMatches[1];
                        
                        tmp = tmp[prop] || (tmp[prop] = []); //checa ou cria o array
                        tmp = tmp[index] || (tmp[index] = {}); ;//vai pro indice
                    }
                    else
                        tmp = tmp[p] || (tmp[p] = {}); //cria o objeto
                }
            })
        },

        getValue(obj, path) {
            let tmp = obj, valor = undefined, i = 0;
            path = path.split('.');
            let getArrayParams = (str) => str.match(/\[(.*?)\]/);
        
            for(var p of path) {
                if (tmp == undefined) {
                    valor = tmp;
                    break;
                }
                if (i == path.length-1) {  //final do caminho, pega o valor
                    let arrayMatches = getArrayParams(p);
                    if (arrayMatches)
                    {
                        let prop = p.split('[')[0];
                        let index = arrayMatches[1];
                        if (tmp[prop] == undefined)
                            valor = tmp[prop];
                        valor = tmp[prop][index];
                        break;
                    }
                    valor = tmp[p];
                    break;
                } else { //navega
                    let arrayMatches = getArrayParams(p);
                    if (arrayMatches) {
                        let prop = p.split('[')[0];
                        let index = arrayMatches[1];
                        if (tmp[prop] == undefined) {
                            valor = tmp[prop];
                            break;
                        }
                        tmp = tmp[prop][index];
                    }
                    else {
                        if (tmp[p] == undefined) {
                            valor = tmp[p];
                            break;
                        }
                        tmp = tmp[p];
                    }
                }
                i++;
            }
            return valor;
        },

        getPropriedadesByName(obj, search, parent) {
            if (obj.constructor.name != 'Object')
                return null;

            let ret = [];

            if (search == undefined || search.constructor.name !== 'Array')
                search = [search || '*'];

            parent = parent || '';
            if (parent)
                parent = `${parent}.`;

            let keys = Object.keys(obj);
            keys.forEach(k => {
                search.forEach(s => {
                    let pos = s.indexOf('*');
                    s = s.replace('*', '');
                    switch (pos) {
                        case -1:
                            if (k == s)
                                ret.push(`${parent}${k}`);

                            break;
                        case 0:
                            if (k.endsWith(s))
                                ret.push(`${parent}${k}`);
                            break;
                        default:
                            if (k.startsWith(s))
                                ret.push(`${parent}${k}`);
                            break;
                    }
                });

                if (obj[k].constructor.name == 'Object')
                {
                    let retTemp = this.getPropriedadesByName(obj[k], search, `${parent}${k}`);
                    ret = [...ret, ...retTemp];
                }
            });

            return ret;
        },

        getPropriedadesValidasDoObjeto(option, ignorar, _path) {

            if (option == undefined)
                return option;

            ignorar = ignorar || [];
            _path = _path || '';
            let retorno = {};

            function ignorePath(key) {
                let path = `*.${key}`;
                if (ignorar.includes(path))
                    return true;
                path = _path.length == 0 ? key : `${_path}.${key}`;
                if (ignorar.includes(path))
                    return true;
                return false;
            }
    
            //se for um array
            if ((option).constructor.name == 'Array') {
                retorno = [];
                option.forEach(i => {
                    retorno.push(this.getPropriedadesValidasDoObjeto(i));
                })
                return retorno;
            }

            if (!['Object', 'Set', 'Function'].includes((option).constructor.name))
                return option;
    
            //pega as keys do objeto
            let keys = Object.keys(option);
            keys.forEach(k => {

                //console.log('# propriedade:', k, _path)

                //verifica se é pra ignorar
                if (ignorePath(k))
                    return;

                //variavel interna (começando com _) ou valor nulo, ignora
                if (k[0] == '_' || option[k] == undefined)
                    return;
    
                let tipo = (option[k]).constructor.name;
    
                //se for funcao, ignora
                if (tipo == 'Function')
                    return;
    
                //se for objeto ou array, faz recursivo
                if (tipo == 'Object' || tipo == 'Array') {
                    let v = this.getPropriedadesValidasDoObjeto(option[k], ignorar, _path.length == 0 ? k : `${_path}.${k}`);
                    if (v != undefined)
                        retorno[k] = v;
                    return;
                }
    
                //outros valores ok
                retorno[k] = option[k];
            });
    
            //ignora objetos vazios
            if (Object.keys(retorno).length == 0)
                return;
    
            return retorno;
        },

        getOptionDev(painel, idBox, prevOptions) {
            //carregar os estrutura gravada no banco
            let options = prevOptions || painel.dadosPainel.estrutura[idBox]?.dev;
            if(options == null || options == undefined)
                return;

            //seta as opções do objeto da dev
            let dadosObjeto = {};
            let keys = Object.keys(options);
            keys.forEach((key, i)=> {
                let option = options[key];

                let command = option.params[0]; //comando, primeiro item do param
                let value = option.params[1]; //valor, segundo item do param
                if (option.array_index != undefined) { //seeeeeee.... tiver a marcacao de que é uma parada de um array...
                    command = `${option.command}[${option.array_index}].${option.params[1]}` //...o comando passa a ser uma concatenação do command com o segundo item do param
                    value = option.params[2]; //...e o valor passa a ser o terceiro, é sempre assim!!
                }

                //o valor nunca pode ser null
                if (value == null)
                    value = undefined;
                //executa essa coisa linda, essa funcao marabilhosa e tesuda que é a "setValue" ❤️
                this.setValue(dadosObjeto, command, value)
            });

            return dadosObjeto;
        },

        ...transferValues
    }
}